export default __webpack_public_path__ + "media/Number5.7f83cfcdc123451329dff0db5bbc335f.mp4";